import React from 'react';
import { Button } from './Button';
import { NeedFromAbby } from './NeedFromAbby';
import type { MembershipPlan } from '../types/content';
type PricingCardProps = {
  plan: MembershipPlan;
};
export function PricingCard({
  plan
}: PricingCardProps) {
  const hi = Boolean(plan.highlighted);
  return <article className={`flex h-full flex-col p-[clamp(1.75rem,2.6vw,3.25rem)] ${hi ? 'bg-charcoal text-cream' : 'bg-white text-graphite ring-1 ring-stone'}`} data-id="element-325" data-mp="1i3hitrurz52m">
      <div className="min-h-[1.75rem]" data-id="element-326" data-mp="2eut5xb5tm13n">
        {plan.highlightLabel && <span className="t-label text-[0.62rem] text-gold" data-id="element-327" data-mp="29uf9yrhhuhlz">{plan.highlightLabel}</span>}
      </div>
      <h3 className={`t-h3 mt-4 ${hi ? '!text-cream' : ''}`} data-id="element-328" data-mp="251m4g1e7b58u">{plan.name}</h3>
      <p className={`t-label mt-2 text-[0.66rem] ${hi ? 'text-cream/75' : 'text-graphite'}`} data-id="element-329" data-mp="212d8cpvouva4">{plan.cadence}</p>
      <div className="mt-8" data-id="element-330" data-mp="2xk9ln5q2u04n">
        <p className={`text-[clamp(1.75rem,1.4rem+0.9vw,2.5rem)] font-light leading-none ${hi ? 'text-cream' : 'text-charcoal'}`} data-id="element-331" data-mp="2xlknv13viztn">Price TBC</p>
        <NeedFromAbby className="mt-3" data-id="element-332" data-mp="32jsrzhukpnxu">{plan.need}</NeedFromAbby>
      </div>
      <p className={`mt-8 ${hi ? 'text-cream/85' : ''}`} data-id="element-333" data-mp="37jfe6gsdqeis">{plan.description}</p>
      <ul className={`mt-8 space-y-3 border-t pt-6 text-[0.95rem] ${hi ? 'border-cream/20' : 'border-stone'}`} data-id="element-334" data-mp="37li1uu627vkc">
        {plan.features.map(f => <li key={f} className="flex items-start gap-4" data-id="element-335" data-mp="2xsu682qtfxn7">
            <span aria-hidden="true" className="mt-[0.7em] h-px w-4 shrink-0 bg-gold" data-id="element-336" data-mp="2xr9eekvvyst1" />
            <span data-id="element-337" data-mp="2jvxkgfpk16d6">{f}</span>
          </li>)}
      </ul>
      <div className="mt-auto pt-10" data-id="element-338" data-mp="2otyygm84ifhs">
        <Button to={`/contact?subject=${plan.id}`} variant={hi ? 'light' : 'outline'} className="w-full" data-id="element-339" data-mp="2oquplbjpqvks">
          Enquire<span className="sr-only" data-id="element-340" data-mp="2eurpeb8f970h"> about the {plan.name}</span>
        </Button>
      </div>
    </article>;
}